import React, { FC } from 'react';
import styled from 'lib/styled';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import sv from 'dayjs/locale/sv';
import NoticeIcon from '../components/NoticeIcon';
import NoticeTitle from '../components/NoticeTitle';
import NoticeDate from '../components/NoticeDate';
import NoticeLabel from '../components/NoticeLabel';
import { TicketNotification } from '../../../../api/models/Notifications';
import NoticeDescription from '../components/NoticeDescription';
import ThemeIcons from '../../Icon/ThemedIcons';
import { ThemeType } from '@app/api/models/Theme';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
const Border = styled.div(({ theme }) => {
    return {
        backgroundColor: theme.colors.alertBackground,
        padding: '16px',
        width: '100%',
        borderRadius: '8px',
        display: 'grid',
        whiteSpace: 'pre-line',
        gridTemplateColumns: 'min-content auto min-content',
        gridTemplateAreas: `
    "icon title label"
    "icon description label"
    "icon date label"
    `,
        columnGap: '1rem',
        rowGap: '0.5rem',
    };
});

const StyledThemedMessages = styled(ThemeIcons.Chat)(({ theme }: { theme: ThemeType }) => {
    return {
        '& g': {
            stroke: theme?.colors?.icons,
        },
        '& path': {
            stroke: theme?.colors?.icons,
        },
        '& polyline': {
            stroke: theme?.colors?.icons,
        },
        '& line': {
            stroke: theme?.colors?.icons,
        },
    };
});

const TicketNotice: FC<TicketNotification & { isCollapsed: boolean }> = ({
    notifiable_type,
    body,
    title,
    created_at,
    isCollapsed,
    link,
    ...rest
}) => {
    const notificationDate = created_at && dayjs(created_at).locale(sv).fromNow();

    return (
        <Link to={link ?? `/${notifiable_type}`}>
            <Border {...rest}>
                <NoticeIcon>
                    <StyledThemedMessages />
                </NoticeIcon>
                <NoticeTitle isCollapsed={isCollapsed} description={title} />
                <NoticeDescription description={body} />
                <NoticeLabel type={'new_ticket'} />
                <NoticeDate when={notificationDate} />
            </Border>
        </Link>
    );
};

export default TicketNotice;
